export const environment = {
  production: true,
  URL_API: 'https://api.dev.cayc.gesthispania.cloud/api',
  idleTimeInMinutes: 60,
  domain: 'front.dev.cayc.gesthispania.cloud'
};
